import Employees from 'tm/employees'
import Notifications from 'tm/notifications'
import JbcIdLogin from 'tm/JbcIdLogin'

export default {
  Employees,
  Notifications,
  JbcIdLogin,
}
